<template>
    <Head title="Anmelden" />

    <div class="mx-auto max-w-3xl pb-8" style="min-height: 50vh">
        <div class="px-4 sm:px-10 sm:text-center max-w-6xl md:mx-auto lg:text-left">
            <div>
                <Teaser :headlines="translate('teaser:headlines')" :small="true" :subline="translate('teaser:subline')"></Teaser>
            </div>
        </div>
        <div class="mt-8">
            <div class="bg-white sm:w-full max-w-3xl sm:mx-auto sm:overflow-hidden">
                <ForgotPasswordBox :email="email" />
            </div>
        </div>
    </div>
</template>

<script>
import {Head, usePage} from '@inertiajs/inertia-vue3'
import Teaser from "../../Components/Common/Teaser";
import translate from "../../../lang";
import ForgotPasswordBox from "../../Components/Auth/ForgotPasswordBox";

export default {
    components: {
        ForgotPasswordBox,
        Teaser,
        Head
    },
    props: {
        email: String
    },
    setup() {
        return {
            translate: translate('auth.forgot')
        }
    }
}
</script>
